import http from "../http-common";

class UOMDataService {
  getAll() {
    return http.get("/uoms");
  }

  getUOMByDescr(condition, sortfield,sorttype) {
    return http.get(`/uoms/search/?unitofmeasureabbrev=${condition}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  get(id) {
    return http.get(`/uoms/${id}`);
  }

  create(data) {
    return http.post("/uoms/newunitofmeasure", data);
  }

  update(id, data) {
    return http.put(`/uoms/${id}`, data);
  }

  delete(id) {
    return http.delete(`/uoms/${id}`);
  }

  deleteAll() {
    return http.delete(`/uoms`);
  }

  findById(id) {
    return http.get(`/uoms?id=${id}`);
  }
}

export default new UOMDataService();